export const themeColors = {
  background: 'var(--background)',
  primary: 'var(--primary)',
  secondary: 'var(--secondary)',
  'card-selected-background': 'var(--card-selected-background)',
  'button-primary': 'var(--button-primary)',
  'card-light-background': 'var(--card-light-background)',
  'primary-foreground': 'var(--primary-foreground)',
  ring: 'var(--ring)',
  input: 'var(--input)',
  destructive: 'var(--destructive)'
} as const;

export const gradients = {
  'strongPink-to-lightPink': 'strongPink-to-lightPink',
  'primary-background-gradient': 'primary-background-gradient',
  'pinto-to-white-gradient': 'pinto-to-white-gradient',
  'secondary-background-gradient': 'secondary-background-gradient'
} as const;

export const screens = {
  xxs: '400px',
  xs: '475px',
  sm: '640px',
  md: '768px',
  mdx: '900px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px'
};
